import React from 'react';

export default () => (
  <h3 className="u-fontsize-medium u-text-center u-mt+">No deleted staff.</h3>
);
